import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixel } from '../../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  variant?: 'ink' | 'gold' | 'premium';
  className?: string;
  checkout?: boolean;
};
const CHECKOUT_URL = 'https://makeoverus.impultienda.ar/checkout';
export function CtaButton({
  children,
  variant = 'ink',
  className = '',
  checkout = false
}: CtaButtonProps) {
  const styles = variant === 'premium' ? 'bg-premium text-ink border border-premium-deep shadow-[0_6px_18px_-6px_rgba(150,110,40,0.55)] hover:bg-premium-deep' : variant === 'gold' ? 'bg-gold text-white hover:bg-[#a5712f]' : 'bg-ink text-cream hover:bg-ink-soft';
  return <a href={checkout ? CHECKOUT_URL : '#offer'} onClick={checkout ? () => trackPixel('InitiateCheckout', {
    value: 27,
    currency: 'USD'
  }) : undefined} className={`group inline-flex items-center justify-center gap-3 px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${styles} ${className}`} data-id="element-76" data-mp="2fe1ta7mifq1x">
      <span data-id="element-77" data-mp="2qbk15m30d53b">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden data-id="element-78" data-mp="2q97ewwq7w8kg" />
    </a>;
}